import { Button } from '@material-ui/core';
import { GenericHeader, SearchBar } from 'components';
import React from 'react';
import { Product } from 'services';
import { CreateModal, Results } from './components';
import ListComp from 'components/ListComp';
import { ecommerce_manager } from 'utils/constants';

const TopupOptionList = props => {

  const Head = props => {
    let { handleCreateOpen, ...rest } = props;
    return (
      <GenericHeader header="All Topup Options" subheader="Topup Option Management" {...rest} >
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Add Topup Option
        </Button>
      </GenericHeader>
    );
  }

  return (
    <ListComp
      listing={Product.list}
      title="Topup Options"
      name="topup_options"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      CreateComp={CreateModal}
      roles={[ecommerce_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "credit_purchase" }}
    />
  );
};

export default TopupOptionList;
